let accessToken = null;

let refreshPromise = null;

export async function loadAccessToken() {
  // let accessToken 있으면 바로 씀
  if (accessToken) return accessToken;

  // 이미 refresh 중이면 같은 Promise 재사용 (동시 호출 방지)
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const response = await fetch("/common/refresh_access/", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      accessToken = response.ok ? (await response.json())?.object?.access ?? null : null;
    } catch {
      accessToken = null;
    }
    return accessToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

// access token 만료 또는 invalid → accessToken 초기화 후 호출부에서 loadAccessToken 다시 호출
export function resetAccessToken() {
  accessToken = null;
}
